import {
    ClientDetailsQuoteRequest,
    CreateQuoteKYCDetailsRequest,
    DirectClientDetailsQuoteRequest,
    GetQuoteDetailsResponse,
    GetQuoteDocumentRequest,
    GetQuoteDocumentResponse,
    GetRecommendedPlansResponse,
    SelectPlanRequest,
    SelectPlanResponse
} from 'Application/models';
import { APICallInstance } from './APICallInstance';
import { AxiosResponse } from 'axios';
import { CreateQuoteDetailsResponse } from 'Application/models';
class QuoteServiceClass {
    addQuoteClientDetails = async (quoteClientDetails: ClientDetailsQuoteRequest) => {
        const url = '/api/v1/quotation';

        try {
            const response: AxiosResponse<CreateQuoteDetailsResponse> = await APICallInstance.post(url, quoteClientDetails);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    addQuoteDirectClientDetails = async (directQuoteClientDetails: DirectClientDetailsQuoteRequest) => {
        const url = '/api/v1/quotation/direct/';

        let { referralName, referralPhoneNumber, redirectToken, ...quoteClientDetails } = directQuoteClientDetails;

        quoteClientDetails = {
            ...quoteClientDetails,
            ...(referralName && { referralName }),
            ...(referralPhoneNumber && { referralPhoneNumber }),
            ...(redirectToken && { redirectToken })
        };

        try {
            const response: AxiosResponse<CreateQuoteDetailsResponse> = await APICallInstance.post(url, quoteClientDetails);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    addQuotePlanDetails = async (quotationNumber: string, quotePlanDetails: SelectPlanRequest) => {
        const url = '/api/v1/quotation/plan';

        try {
            const response: AxiosResponse<SelectPlanResponse> = await APICallInstance.put(url, quotePlanDetails, {
                params: {
                    quotationNumber: quotationNumber
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    addQuotePlanDetailsDirectClient = async (quotationNumber: string, quotePlanDetails: SelectPlanRequest) => {
        const url = '/api/v1/quotation/direct/plan/';

        try {
            const response: AxiosResponse<SelectPlanResponse> = await APICallInstance.put(url, quotePlanDetails, {
                params: {
                    quotationNumber: quotationNumber
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    addQuoteKYCDetails = async (quotationNumber: string, quoteKYCDetails: CreateQuoteKYCDetailsRequest) => {
        const url = '/api/v1/customer/details';

        try {
            const response: AxiosResponse<CreateQuoteDetailsResponse> = await APICallInstance.put(
                url,
                {
                    mainCustomer: quoteKYCDetails.mainCustomer,
                    otherTravellerDetails: quoteKYCDetails.dependants.map((dependant) => ({
                        fullName: dependant.firstName + ' ' + dependant.otherNames,
                        dateOfBirth: dependant.dateOfBirth,
                        passportNumber: dependant.identificationNumber,
                        fileName: dependant.filenames ? dependant.filenames![0] || '' : ''
                    })),
                    hasConsented: quoteKYCDetails.hasConsented
                },
                {
                    params: {
                        quotationNumber: quotationNumber
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    getQuoteDetails = async (quoteId: string) => {
        const url = '/api/v1/quotation/quotation-number';

        try {
            const response: AxiosResponse<GetQuoteDetailsResponse> = await APICallInstance.get(url, {
                params: {
                    quoteId
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    getRecommendedPlans = async (quotationNumber: string) => {
        const url = 'api/v1/quotation/recommended/plans';

        try {
            const response: AxiosResponse<GetRecommendedPlansResponse> = await APICallInstance.get(url, {
                params: {
                    quotationNumber: quotationNumber
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    getQuoteDocument = async (quoteId: string, getQuoteDocumentDetails: GetQuoteDocumentRequest) => {
        const url = '/api/v1/quotation/download';

        try {
            const response: AxiosResponse<GetQuoteDocumentResponse> = await APICallInstance.post(url, getQuoteDocumentDetails, {
                params: {
                    quoteId
                },
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    };
}

export const QuoteService = new QuoteServiceClass();
